import React from 'react';

/** Header of the pricing page while it loads: the entity card, then the guarantees block. */
export const PricingHeaderSkeleton: React.FC = () => {
  return (
    <div className="relative flex flex-col xl:flex-row gap-4 p-4 border bg-white rounded-xl shadow">
      {/* Entity card */}
      <div className="flex-none w-full xl:w-[250px] 2xl:w-[320px] animate-pulse">
        <div className="flex h-28 items-center gap-3 p-4 border rounded-xl bg-gray-50">
          <div className="flex-none w-12 h-12 bg-gray-300 rounded-full"></div>
          <div className="flex flex-col gap-2">
            <div className="w-24 h-4 bg-gray-300 rounded"></div>
            <div className="w-32 h-3 bg-gray-300 rounded"></div>
            <div className="w-20 h-3 bg-gray-300 rounded"></div>
          </div>
        </div>
      </div>

      {/* Guarantees block */}
      <div className="flex flex-col grow gap-3 p-4 border rounded-xl bg-gray-50 animate-pulse">
        <div className="w-40 h-4 bg-gray-300 rounded"></div>
        <div className="flex flex-wrap gap-2">
          <div className="w-24 h-5 bg-gray-300 rounded-full"></div>
          <div className="w-32 h-5 bg-gray-300 rounded-full"></div>
          <div className="w-20 h-5 bg-gray-300 rounded-full"></div>
          <div className="w-28 h-5 bg-gray-300 rounded-full"></div>
        </div>
        <div className="w-56 h-3 bg-gray-300 rounded"></div>
      </div>
    </div>
  );
};
